import { useRef, useEffect, useState } from "react";

import "./index.css";

function ImageWidgetContent(props) {
  const ref = useRef();
  const [imgSrc, setImgSrc] = useState("");

  useEffect(() => {
    if (props.image && props.image.length > 0) {
      setImgSrc(props.image);
    }
  }, []);

  function onChange() {
    const { current } = ref;
    if (current.files && current.files.length > 0) {
      const file = current.files[0];
      const reader = new FileReader();
      reader.onloadend = () => {
        const res = reader.result;
        props.onSetWidgets("image", res);
        setImgSrc(res);
      }
      reader.readAsDataURL(file);
    }
  }
  return (
    <div className="ImageWidgetContent">
      <input type="file"
        accept="image/*"
        ref={ref}
        onChange={onChange}
      />

      {imgSrc && imgSrc.length > 0 &&
        <div className="ImageWidgetContentImgContainer">
          <div
            style={{ backgroundImage: `url(${imgSrc})` }}
            className="ImageWidgetContentImg"
          />
        </div>
      }
    </div>
  )
}

export default ImageWidgetContent;
